import Api from './apis/api.js'
import RecaptchaV3 from './recaptcha.js'
import { setError, clearError } from './forms.js'
import gtagV4 from './google-analytics-v4.js'

/**
 * Available steps
 *
 * @var array
 */
const steps = [1, 2, 3, 'send', 'direct']

/**
 * Steps fields
 *
 * @var array
 */
const stepsField = ['message', 'email', '', 'phone']

/**
 * Last step
 *
 * @var int
 */
const lastStep = 3

/**
 * Init Contact step
 *
 * @param string selector Container query selector
 * @param bool direct Direct form with no steps
 */
function create(selector, direct = false) {
  const form = document.querySelector(selector)
  if (!form) return

  //init step
  form.step = direct ? 'direct' : 1

  const btn = form.querySelector('[type="submit"]')

  form.addEventListener('submit', (e) => {
    e.preventDefault()

    const stepIndex = steps.findIndex((step) => step == form.step)

    const inputMessage = form.elements.message
    const inputEmail = form.elements.email
    const inputPhone = form.elements.phone

    const params = {
      page: document.location.pathname + document.location.search,
    }

    //required message
    if (!inputMessage.value) {
      setError('Inserire un messaggio', inputMessage)
      return
    } else clearError(inputMessage)

    params.message = inputMessage.value

    //required email
    if (stepIndex > 0) {
      if (!inputEmail.value) {
        setError('Inserire un indirizzo email', inputEmail)
        return
      } else clearError(inputEmail)

      params.email = inputEmail.value
    }

    params.phone = inputPhone.value || null

    btn.disabled = true
    btn.classList.add('loading')

    RecaptchaV3.send((recaptcha_token) => {
      Api.post(`contact-step/${steps[stepIndex]}`, {
        ...params,
        recaptcha_token,
      })
        .then(({ data }) => {
          const field = stepsField[stepIndex]

          const eventName = direct ? 'direct' : `field_${field}`

          //analytics
          gtagV4(`contact_${eventName}`, params[field] ? true : false)

          //last step
          if (!data) {
            form.replaceWith(
              'Messaggio inviato correttamente. Verrete ricontattati al più presto dal nostro staff.'
            )
            gtagV4('contact_send')
            return
          }

          //next step
          form.step = data == lastStep ? 'send' : data
          //active
          form
            .querySelector(`.step[data-step="${data}"]`)
            .classList.add('active')
        })
        .catch(({ message }) => {
          setError(message, inputMessage)
        })
        .finally(() => {
          btn.disabled = false
          btn.classList.remove('loading')
        })
    })
  })
}

export default {
  create,
}
